import { gql, MutationHookOptions, useMutation } from "@apollo/client"
import { HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT } from "~/app/fragments/HiringFormEmploymentFields"
import {
  UpdateAdditionalAgreementsAfterSubmissionInput,
  UpdateAdditionalAgreementsAfterSubmissionPayload,
} from "@oysterhr/schema"

const HIRING_FTE_COMPANY_UPDATE_ADDITIONAL_AGREEMENTS_AFTER_SUBMISSION = gql`
  mutation HiringFTECompanyUpdateAdditionalAgreementsAfterSubmission(
    $employmentId: ID!
    $actorParty: AgreementPartyTypeEnum!
    $hiringId: ID!
    $restrictiveCovenantsAttributes: RestrictiveCovenantsInput!
    $editActionStartTime: ISO8601DateTime!
  ) {
    updateAdditionalAgreementsAfterSubmission(
      input: {
        employmentId: $employmentId
        actorParty: $actorParty
        hiringId: $hiringId
        restrictiveCovenantsAttributes: $restrictiveCovenantsAttributes
        editActionStartTime: $editActionStartTime
      }
    ) {
      employment {
        ...HiringFormEmploymentFields
      }
      errors
      fieldErrors {
        fieldId
        message
        target
      }
    }
  }
  ${HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT}
`

export const useUpdateAdditionalAgreementsAfterSubmission = (
  options?: MutationHookOptions<
    { updateAdditionalAgreementsAfterSubmission: UpdateAdditionalAgreementsAfterSubmissionPayload },
    UpdateAdditionalAgreementsAfterSubmissionInput
  >,
) => {
  return useMutation<
    { updateAdditionalAgreementsAfterSubmission: UpdateAdditionalAgreementsAfterSubmissionPayload },
    UpdateAdditionalAgreementsAfterSubmissionInput
  >(HIRING_FTE_COMPANY_UPDATE_ADDITIONAL_AGREEMENTS_AFTER_SUBMISSION, options)
}
